document.addEventListener('DOMContentLoaded', function () {
    const gamingStationsTabsBlocks = Array.from(document.querySelectorAll('section.gaming-stations-tabs'));
    gamingStationsTabsBlocks.forEach(gamingStationsTabsBlock => {
        // Add interection observer to each block that starts the video when it's in the viewport and stops it when it's not
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const video = gamingStationsTabsBlock.querySelector('.tab-content.is-active .gs-video');
                if (!video) {
                    return;
                }
                if (entry.isIntersecting) {
                    video.play();
                }
                else {
                    video.pause();
                }
            });
        });
        observer.observe(gamingStationsTabsBlock);
        // Add "tabChanged" listener on tab control to play the new active video and stop the previous one
        const tabsControl = gamingStationsTabsBlock.querySelector('.tab-controls-container');
        tabsControl?.addEventListener('tabChanged', event => {
            const typedEvent = event;
            typedEvent.detail.newTabContentEl.forEach(newContent => {
                const newVideo = newContent.querySelector('.gs-video');
                if (newVideo) {
                    newVideo.play();
                }
            });
            typedEvent.detail.prevTabContentEl.forEach(prevContent => {
                const prevVideo = prevContent.querySelector('.gs-video');
                if (prevVideo) {
                    prevVideo.pause();
                }
            });
        });
    });
});
export {};
